import { all, fork } from 'redux-saga/effects';

import fetchMessageBox from 'saga/fetchMessageBox';
import fetchLogin from 'saga/fetchLogin';
import fetchAccount from 'saga/fetchAccount';
import fetchLicense from 'saga/fetchLicense';
import fetchAdapter from 'saga/fetchAdapter';
import fetchUniAdapter from 'saga/fetchUniAdapter';
import fetchSetting from 'saga/fetchSetting';
import fetchStats from 'saga/fetchStats';
import fetchMonitoring from 'saga/fetchMonitoring';

export default function* sagas() {
	yield all([
		fork(fetchMessageBox),
		fork(fetchLogin),
		fork(fetchAccount),
		fork(fetchLicense),
		fork(fetchAdapter),
		fork(fetchUniAdapter),
		fork(fetchSetting),
		fork(fetchStats),
		fork(fetchMonitoring)
	])
}